import axios from "axios";
import { API_BASE_URL } from "../config/api.config";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000, // Tetap 60 detik, tapi bisa dikurangi jika sering timeout,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      // const user = JSON.parse(localStorage.getItem("siskop2mi_user"));

      // // Validasi token lebih ketat: pastikan ada dan bukan string kosong
      // if (user && (user.token || user.accessToken)) {
      //   const token = user.token || user.accessToken;
      //   if (token && typeof token === "string" && token.trim() !== "") {
      //     config.headers["Authorization"] = `Bearer ${token}`;
      //   } else {
      //     // Jika token invalid, hapus dan reject (tanpa redirect di sini)
      //     localStorage.removeItem("siskop2mi_user");
      //     return Promise.reject(new Error("Invalid token"));
      //   }
      // }

      config.metadata = { startTime: new Date().getTime() };
      return config;
    } catch (error) {
      // Jika parsing localStorage gagal, hapus dan reject
      // localStorage.removeItem("siskop2mi_user");
      return Promise.reject(error);
    }
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => {
    const endTime = Date.now();
    response.responseTime = endTime - response.config.metadata.startTime;
    return response;
  },
  async (error) => {
    // Handler untuk network errors (tidak ada error.response) - JANGAN redirect otomatis
    if (!error.response) {
      console.error("Network Error (tidak redirect):", error.message);
      // Asumsikan bukan auth issue; reject agar ditangani di komponen (misalnya, tampilkan pesan)
      // localStorage.removeItem("siskop2mi_user");
      // window.location.replace("/login");
      return Promise.reject(error);
    }

    const originalRequest = error.config;

    // Handler untuk 401 Unauthorized - BARU redirect di sini
    // if (error.response.status === 401 && !originalRequest._retry) {
    //   originalRequest._retry = true;
    //   console.warn("401 Unauthorized: Logging out and redirecting to login");
    //   // localStorage.removeItem("siskop2mi_user");
    //   // window.location.replace("/login");
    //   return Promise.reject(error);
    // }

    // Handler untuk 429 Too Many Requests - Retry tanpa redirect
    if (error.response.status === 429) {
      const retryAfter = error.response.headers["retry-after"] || 5;
      console.warn(
        `429 Too Many Requests: Retrying after ${retryAfter} seconds (tidak redirect)`,
      );
      await new Promise((resolve) => setTimeout(resolve, retryAfter * 1000));
      return axiosInstance(originalRequest);
    }

    // Untuk error HTTP lain (misalnya 500, 404) - Reject tanpa redirect
    console.error(`API Error ${error.response.status}:`, error.response.data);
    return Promise.reject(error);
  },
);

export default axiosInstance;
